import { render } from "./ResourseTable.vue?vue&type=template&id=643131f8&scoped=true"
import script from "./ResourseTable.vue?vue&type=script&lang=js"
export * from "./ResourseTable.vue?vue&type=script&lang=js"

import "./ResourseTable.vue?vue&type=style&index=0&id=643131f8&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643131f8"]])

export default __exports__